/* eslint  @typescript-eslint/ban-ts-comment: 0 */ // --> OFF
import CommonFunctions from "../../wwwroot_src/src/GlobalScripts/CommonFunctions";
import { EntityGridBase } from "./Grid/EntityGridBase";

export class MultiSelectPopup extends kendo.ui.Widget {
    private grid: EntityGridBase;
    private countLabelId: string;
    private readUrl: string;
    private buttonName: string;
    private enabled: boolean;

    constructor(element: Element, options) {
        super(element, options);
        this.countLabelId = options.countLabel;
        this.readUrl = options.readUrl;
        this.buttonName = options.buttonName;
        this.enabled = options.enabled;
    }

    openMultiSelectPopupWindow = (url: string, title: string): JQueryPromise<void> => {
        const deferred = jQuery.Deferred<void>();
        const wnd = CommonFunctions.openInPopupWindow(url, title, true, 600);
        wnd.one("close", (e) => {
            if (!e.userTriggered && this.grid) {
                const idArray = this.grid.selectedIdsAsString().split(',').filter((x) => x); //filter needed in case the string is empty
                $(`#${this.countLabelId}`).text(idArray.length);
                $(this.element).val(this.grid.selectedIdsAsString());
            }
            deferred.resolve();
        });
        return deferred;
    }

    getSelectedItemsAsString() {
        return $(this.element).val();
    }

    getSelectedCount() {
        const idArray = ($(this.element).val() as string).split(',').filter((x) => x); //filter needed in case the string is empty
        return idArray.length;
    }

    enableSelectionButton() {
        if (this.enabled) {
            $(`#${this.buttonName}`).data().kendoButton.enable();
        }
    }

    disableSelectionButton() {
        $(`#${this.buttonName}`).data().kendoButton.enable(false);
    }

    hasSelectedItems() {
        const value = $(this.element).val();
        if (value) {
            return true;
        }
        return false;
    }

    gridInitialized = (grid: EntityGridBase) => {
        this.grid = grid;
        this.grid.getKendoGrid().element.find(".k-filter-row").toggle();
        const stringValue = $(this.element).val();
        if (stringValue) {
            const ids = (stringValue as string).split(',');
            this.grid.selectByIds(ids);
        }
    }

    buttonClickHandler = (e) => {
        e.preventDefault();
        const button = e.sender.element.data().kendoButton;
        button.enable(false);
        this.openMultiSelectPopupWindow(this.readUrl, TextResources.Views_AuswahlTreffen).always(() => button.enable(true));
    }
}

// Create an alias of the prototype (required by kendo.ui.plugin)
MultiSelectPopup.fn = MultiSelectPopup.prototype;
// Deep clone the widget default options
MultiSelectPopup.fn.options = $.extend(true, {}, kendo.ui.Widget.fn.options);
// Specify the name of your Kendo UI widget. Used to create the corresponding jQuery plugin.
MultiSelectPopup.fn.options.name = "MultiSelectPopup";
// Create a jQuery plugin.
kendo.ui.plugin(MultiSelectPopup);
